import classNames from "classnames";

import styles from "./Button.module.css";

type Props = {
  className?: string;
  children: string;
  to: string;
};

export default function Button(prop: Props) {
  return (
    <a
      className={classNames(
        styles.filled,
        styles.link,
        prop.className,
        styles.button,
      )}
      href={prop.to}
    >
      {prop.children}
    </a>
  );
}
